<template>
    <InputField
        :value="value"
        type="text"
        :label="label"
        :disabled="disabled"
        :description="description"
        :help-button-text="helpButtonText"
        :min-length="minLength"
        :max-length="maxLength"
        :required="required"
        :error-messages="errorMessages"
        :placeholder="placeholder"
        :status="status"
        :autocomplete="autocomplete"
        @input="($event) => $emit('input', $event)"
        @change="($event) => $emit('change', $event)"
        @blur="($event) => $emit('blur', $event)"
    />
</template>
<script setup lang="ts">
import InputField from './InputField.vue';

export type TextFieldAutoCompleteOptions =
    | 'off'
    | 'on'
    | 'name'
    | 'honorific-prefix'
    | 'given-name'
    | 'additional-name'
    | 'family-name'
    | 'honorific-suffix'
    | 'nickname'
    | 'email'
    | 'username'
    | 'organization-title'
    | 'organization'
    | 'street-address'
    | 'address-line-1'
    | 'address-line-2'
    | 'address-line-3'
    | 'address-level-4'
    | 'address-level-3'
    | 'address-level-2'
    | 'address-level-1'
    | 'country'
    | 'country-name'
    | 'postal-code'
    | 'cc-name'
    | 'cc-given-name'
    | 'cc-additional-name'
    | 'cc-family-name'
    | 'cc-number'
    | 'cc-exp'
    | 'cc-exp-month'
    | 'cc-exp-year'
    | 'cc-csc'
    | 'cc-type'
    | 'transaction-currency'
    | 'transaction-amount'
    | 'language'
    | 'bday'
    | 'bday-day'
    | 'bday-month'
    | 'bday-year'
    | 'sex'
    | 'tel'
    | 'tel-country-code'
    | 'tel-national'
    | 'tel-area-code'
    | 'tel-local'
    | 'tel-local-prefix'
    | 'tel-local-suffix'
    | 'tel-extension'
    | 'impp'
    | 'url'
    | 'photo';

type TextFieldProps = {
    value: string;
    label: string;
    disabled?: boolean;
    description?: string;
    helpButtonText?: string;
    required?: boolean;
    minLength?: number;
    maxLength?: number;
    errorMessages?: string[];
    placeholder?: string;
    status?: 'overridden';
    autocomplete?: TextFieldAutoCompleteOptions;
};

defineProps<TextFieldProps>();
defineEmits<{ (e: 'input', v: Event): void; (e: 'change', v: Event): void; (e: 'blur', v: Event): void }>();
</script>
